import async from "async";
import _ from "lodash";
import ApiRequest from "@/helpers/ApiRequest";
import general from "@/helpers/general";
import GetHeaders from "@/helpers/GetHeaders";
import ParseTTC from "@/helpers/ParseTTC";
import {
  SAVE_DOCUMENTS_DATA,
  SAVE_FIELDS,
  SAVE_INDICES,
  SAVE_METAS,
  SAVE_TTC,
  SAVE_TTC_COLOR_METRIC,
  SAVE_WIKIS
} from "@/store/mutation-types";

export default {
  actions: {
    loadTTC: ({ commit, rootState }, payload = null) => {
      let responses = [];
      return new Promise(resolve => {
        const cb = async (page, continuation) => {
          return ApiRequest.explorePost(
            "hierarchydata",
            {
              init: payload? payload.state:!rootState.api.apiReady,
              recentyear: payload? payload.recentYear:0,
              startyear: payload? payload.startYear:0,
              stopyear: payload? payload.stopYear:0,
              lowerlimit: 7,
              page: page || 1,
              continuation: continuation || false
            },
            GetHeaders.dataHeaders()
          );
        };

        cb().then(res => {
          responses.push(res.data);
          const pagesZeroBased = res.data.pages - 1;
          async.times(
            pagesZeroBased,
            (n, next) => {
              const nextPage = n + 2;
              cb(nextPage, true).then(res => {
                responses.push(res.data);
                next();
              });
            },
            () => {
              resolve();
            }
          );
        });
      }).then(() => {
        // Sort data after fetching in parallel (receiving order might be shifted) and concatenate it
        const fullResponse = _.orderBy(responses, ["page"])
          .map(r => r.body)
          .join("");

        let ttcData = JSON.parse(fullResponse);
        // Extract indices
        if (ttcData) {
          let indices = [];
          let fields = [];
          let documents = [];
          _.each(ttcData.indices, i => {
            indices.push({
              type: general.slug(i),
              name: i
            });
          });
          commit(SAVE_INDICES, { indices: indices });
          fields = ttcData.fields;
          if(rootState.layout.fieldsState){
            commit(SAVE_FIELDS, { fields: fields });
          }
          if(rootState.layout.docsState){
            documents = ttcData.documents;
            commit(SAVE_DOCUMENTS_DATA, { documents: documents });
          }
        }

        // Extract wikis
        if(rootState.layout.ttcState){
        if (ttcData.wiki) {
          _.each(ttcData.wiki.categories, wc => {
            wc.open = rootState.filter.wikisOpen.includes(wc._id);
            _.each(wc.children, wcc => {
              wcc.open = rootState.filter.wikisOpen.includes(wcc._id);
            });
          });
          commit(SAVE_WIKIS, { wikis: ttcData.wiki.categories });
        }

        // Extract TTC
        const ttc = ParseTTC.parse(ttcData.ttc, ttcData.data);
        commit(SAVE_TTC, { ttc: ttc });

        }
        // Save metas
        commit(SAVE_METAS, { metas: ttcData.metas });
        
      });
    },
    getTTC: ({ state }) => {
      return state.ttc;
    },
    saveTTCColorMetric: ({ commit }, payload) => {
      commit(SAVE_TTC_COLOR_METRIC, {
        ttc_color_metric: payload.ttcColorMetric
      });
    },
    searchTTCConcepts: ({ state }, payload) => {
      let filteredConcepts = [];
      _.each(state.ttc, topic => {
        _.each(topic.children, theme => {
          let filtered = theme.children.filter(concept =>
            concept.name.includes(payload.query.toLowerCase())
          );
          filteredConcepts.push(...filtered);
        });
      });
      return filteredConcepts;
    },
    searchTTCThemes: ({ state }, payload) => {
      let filteredThemes = [];
      _.each(state.ttc, topic => {
        _.each(topic.children, theme => {
          let filtered = theme.children.filter(concept =>
            concept.name.includes(payload.query)
          );
          if (filtered.length) {
            filteredThemes.push(theme);
          }
        });
      });
      return filteredThemes;
    },
    searchIndices: (_, payload) => {
      return ApiRequest.exploreGet(
        "search" + "?query=" + payload.query + "&index=" + payload.index,
        GetHeaders.dataHeaders()
      ).then(res => {
        return res.data;
      });
    }
  },
  getters: {
    ttcLookup: state => payload => {
      let found = null;

      // Use for loops because forEach can't be stopped
      // https://medium.com/front-end-weekly/3-things-you-didnt-know-about-the-foreach-loop-in-js-ff02cec465b1
      for (let i1 = 0; i1 < state.ttc.length; i1++) {
        const topic = state.ttc[i1];
        if (topic.id === payload.id) {
          found = topic;
          break;
        }
        for (let i2 = 0; i2 < topic.children.length; i2++) {
          const theme = topic.children[i2];
          if (theme.id === payload.id) {
            found = theme;
            break;
          }
          for (let i3 = 0; i3 < theme.children.length; i3++) {
            const concept = theme.children[i3];
            if (concept.id === payload.id) {
              found = concept;
              break;
            }
          }
        }
      }

      return found;
    }
  },
  mutations: {
    [SAVE_TTC_COLOR_METRIC](state, payload) {
      state.ttcColorMetric = payload.ttc_color_metric;
    },
    [SAVE_TTC](state, payload) {
      state.ttc = payload.ttc;
    },
    [SAVE_INDICES](state, payload) {
      state.indices = payload.indices;
    },
    [SAVE_METAS](state, payload) {
      state.metas = payload.metas;
    }
  },
  state: {
    indices: [],
    metas: [],
    ttc: [],
    ttcColorMetric: "recency",
    ttcData: []
  }
};
